import React from 'react';
import { Box, Checkbox, MenuItem, Select, Typography } from '@mui/material';
import { withLanguage } from '../common/Texts';
import { dashboardTokens as t } from './tokens';

export default function FilterDropdown({
    label,
    options,
    value,
    onChange,
    language,
}) {
    const tr = withLanguage(language);
    const allLabel = tr('all') || 'All';
    const count = value.length;
    const selectedTexts = options
        .filter((o) => value.includes(o.value))
        .map((o) => o.text);

    const renderValue = () => {
        if (count === 0) return allLabel;
        return selectedTexts.join(', ');
    };

    return (
        <Box sx={{ minWidth: 0 }}>
            <Box sx={{ mb: 0.75 }}>
                <Typography component="div" noWrap sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: t.color.fgMuted,
                }}>
                    {label}
                </Typography>
                <Typography component="div" sx={{
                    fontSize: 11,
                    color: t.color.primary,
                    fontWeight: 600,
                    visibility: count > 0 ? 'visible' : 'hidden',
                }}>
                    {count} {tr('selected') || 'selected'}
                </Typography>
            </Box>
            <Select
                multiple
                fullWidth
                size="small"
                displayEmpty
                value={value}
                onChange={onChange}
                renderValue={renderValue}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            mt: 0.5,
                            borderRadius: `${t.radius.md}px`,
                            border: `1px solid ${t.color.border}`,
                            boxShadow: t.shadow.lg,
                            maxHeight: 320,
                        },
                    },
                }}
                sx={{
                    backgroundColor: t.color.surface,
                    borderRadius: `${t.radius.md}px`,
                    fontSize: 14,
                    color: count === 0 ? t.color.fgSubtle : t.color.fg,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: t.color.border,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: t.color.primaryBorder,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: t.color.primary,
                    },
                    '& .MuiSelect-select': {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                }}
            >
                {options.map((opt) => (
                    <MenuItem
                        key={opt.value}
                        value={opt.value}
                        sx={{
                            fontSize: 14,
                            '&.Mui-selected': {
                                backgroundColor: t.color.primarySoft,
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: t.color.primarySoft,
                            },
                        }}
                    >
                        <Checkbox
                            checked={value.includes(opt.value)}
                            size="small"
                            sx={{ mr: 1, p: 0.5, color: t.color.fgSubtle, '&.Mui-checked': { color: t.color.primary } }}
                        />
                        {opt.text}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}
